export default __webpack_public_path__ + "static/media/courthouse.d6b9bb08.svg";